module.exports = __webpack_public_path__ + "img/back-white.8b033685.svg";